import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

import { SnTip } from '@lib/api/entities';
import { SnAspectRatio } from '@lib/common/enums';
import { FsMap, FsMapMarker, FsMarkerSymbolType } from '@lib/geo/map';
import { COLORS } from '@lib/ui/theme';

@Component({
  selector: 'sn-location-map',
  templateUrl: './location-map.component.html',
  styleUrls: ['./location-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.paddingTop.%]': 'ASPECT_RATIO.HD',
  },
})
export class LocationMapComponent implements OnChanges {
  @Input()
  public location: SnTip;

  @Output() public readonly map = new EventEmitter<FsMap>();

  public readonly ASPECT_RATIO = SnAspectRatio;

  private _fsMap: FsMap;
  private _pointMarker: FsMapMarker;

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if ('location' in changes && this._pointMarker) {
      this._pointMarker.setLonLat(this.location.geometry.coordinates);
    }
  }

  public onMapInit(fsMap: FsMap): void {
    this._fsMap = fsMap;
    this._fsMap.setCenter(this.location.geometry.coordinates);
    this._pointMarker = new FsMapMarker(this._fsMap, {
      lonLat: {
        lon: this.location.geometry.coordinates[0],
        lat: this.location.geometry.coordinates[1],
      },
      color: COLORS['red-600'],
      type: FsMarkerSymbolType.PIN,
      clickable: false,
      draggable: false,
      size: '20px',
    });

    this.map.next(this._fsMap);
  }
}
